<template>
	<div>
		<modalconfirm ref="modalSaveProduct" @action="saveProduct"/>
		<div class="text-h5">Setting Produk Belanja Stockist</div>
		<v-card class="mt-3" outlined>
			<v-card-text class="pt-2">
				<v-row>
					<v-col cols="12" >
						<v-data-table v-model="product_po" show-select item-key="product_id" disable-pagination :headers="headerWarehouse" :items="productWarehouse" hide-default-footer class="mt-2" no-data-text="Belum ada produk tersedia">
							<template v-slot:item.product_price="{ item }">
								<div>{{ item.product_price | toNumber }}</div>
							</template>
						</v-data-table>
					</v-col>
				</v-row>
			</v-card-text>
			<v-card-actions class="px-4 pb-4">
				<v-spacer></v-spacer>
				<v-btn color="primary darken-1" :disabled="product_po.length == 0" depressed class="text-capitalize" @click="sync">Simpan</v-btn>
			</v-card-actions>
		</v-card>
	</div>
</template>

<script>

import {mapActions, mapState, mapMutations} from 'vuex'

export default {
	inject: ['theme'],
	components: {
	},
	data() {
		return {
			product_po: [],
			product_warehouse: [],
			paramGet: '',
			headerWarehouse: [
			{ text: 'Nama Produk', align: 'start', value: 'product_name', sortable: true},
			{ text: 'Kode Produk', value: 'product_code', sortable: false},
			{ text: 'Harga Produk', value: 'product_price', align: 'end'},
			],
            productParams: {
                limit: 1000
            }
		}
	},
	props: {
	},
	computed: {
		...mapState('purchaseOrderStockist', ['productWarehouse', 'productPO']),
	},
	methods: {
		...mapActions('purchaseOrderStockist', ['getProductWarehouse', 'saveProductPOStockist']),
		...mapMutations(['setOverlay']),

		sync() {
			let msg = `Yakin ingin menyimpan data?`
			this.$refs.modalSaveProduct.showConfirm()
			this.$refs.modalSaveProduct.setMessage(msg)
		},
		async saveProduct() {
			await this.setOverlay(true)
			await this.$refs.modalSaveProduct.hideConfirm()
			let params = await {
				product: this.product_po
			}

			await this.saveProductPOStockist(params).then(() => {
				this.resetForm()
			})
			await this.setOverlay(false)
		},
		resetForm() {
			this.product_warehouse = []
			this.product_po = []
			this.getProductWH(this.productParams)
		},
		async getProductWH() {
			await this.getProductWarehouse(this.productParams).then((response) => {
				if (response.length > 0) {
					response.map( (el) => {
						if (el.product_to_po_mb == 'true') {
							this.product_po.push(el)
						}
					})
				}
			}).catch(() => {
				//.log(response)
			})
		}
	},
	created() {
		this.$store.dispatch('setPageTitle', `Setting Produk Belanja Stockist`)
		this.getProductWH()
	},
	beforeDestroy() {
	},
	watch: {
		
	}
}
</script>